import { Menu, Submenu } from '../../_models/menu';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchMenu'
})
export class SearchMenuPipe implements PipeTransform {

  transform(items: any[], searchText: string): any[] {
    
    if (!items) { return []; }
    if (!searchText) { return items; }


    console.log("Filtering menu " , items);

    //searchText =  searchText.toLowerCase( );
    return items.filter(submenu => {
      //return submenu.label.toLowerCase().includes(searchText.toLowerCase( ))  || submenu.parentlabel.toLowerCase().includes(searchText.toLowerCase( )) ;
      console.log("Filtering menu " , searchText.toLowerCase( ));
      
      return submenu.label.toLowerCase().includes(searchText.toLowerCase( )) ;
    });

  }
}
